import React, { useState, useRef, useEffect } from "react";
import { ReactComponent as SendMessageIcon } from "../../../assets/icons/SendIcon.svg";
import { ReactComponent as AttachmentIcon } from "../../../assets/icons/AttachmentIcon.svg";
import { bytesToSize, getFullName, notify, containsDisallowedURL,isAllowedMeetingURL } from "../../../util/helpers";
import { useSelector } from "react-redux";

export const ChatInputComponent = (props) => {
  let [messageText, setMessageText] = useState("");
  const [messageSending, setMessageSending] = useState(false);
  const [hasAttachment, setHasAttachment] = useState(false);
  const [attached, setAttachment] = useState(null);
  const [preview, setPreview] = useState(null);

  const attachment = useRef();
  const spanMessage = useRef();
  const sendMessageButton = useRef();
  const { user, selectedClinic, selectedProvider } = useSelector(
    (state) => state.app
  );
  const senderName = getFullName(user);
  const hasMaliciousContent = (text) => {
  const lowerText = text.toLowerCase();
  const blacklistPatterns = [
    /<script.*?>.*?<\/script>/g,
    /<.*?onerror=.*?>/g,
    /<img.*?>/g,
    /javascript:/g,
    /<iframe.*?>.*?<\/iframe>/g,
  ];
  const hasBlacklistedTag = blacklistPatterns.some((pattern) => pattern.test(lowerText));
  const hasDisallowedUrl = containsDisallowedURL(text);
  return hasBlacklistedTag || hasDisallowedUrl;
};

  const processMessage = () => {
    if (messageSending) {
      notify("Please wait while your previous message is being sent!", "info");
      return false;
    }
    if ((messageText && messageText.trim().length > 0) || attached) {
      if ( hasMaliciousContent(messageText || '')) {
          notify("Your message contains potentially dangerous content and was blocked.", "warning");
          setMessageSending(false);
          return;
        }
      // BLOCK if disallowed URL
    if (containsDisallowedURL(messageText)) {
        notify("Only Zoom, Google Meet, Teams,carepatron,surrymedicalministries or Doxy links are allowed.", "warning");
        return;
      }
      messageText = `${messageText} [From : ${senderName}]`      
      props?.sendMessage(
        hasAttachment ? "image" : "text",
        props?.peerID,
        { text: messageText },
        setMessageSending,
        setMessageText,
        props?.setClinicianChatMessage,
        props?.clinicianId,
        attached ? attached : null,
        setAttachment,
        props?.patientEmail,
        senderName,
      );
      if (spanMessage.current) {
        spanMessage.current.textContent = "";
      }
      if (props?.setLatestMessage) {
        props.setLatestMessage({
          message: { text: messageText },
          peerID: props?.peerID,
          updateBadge: false,
        });
      }
      setMessageText("");
    } else {
      notify("Message can not be empty!", "info");
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", keydownHandler);

    return () => {
      document.removeEventListener("keydown", keydownHandler);
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    processMessage();
  };

  const keydownHandler = (e) => {
    //* If Ctrl + Enter is pressed, try sending the message
    if (e.keyCode === 13 && e.ctrlKey) {
      try {
        sendMessageButton.current.click();
      } catch (e) {}
    }
  };

  useEffect(() => {
    if (attached) {
      setPreview({
        url: URL.createObjectURL(attached),
        name: attached?.name,
        size: attached?.size,
      });
      setHasAttachment(true);
    } else {
      setPreview(null);
      attachment.current.value = null;
      setHasAttachment(false);
    }
  }, [attached]);

  return (
    <form
      className={`chat-input-container ${props.classnames}`}
      style={props.styles}
      onSubmit={handleSubmit}
    >
      <AttachmentIcon
        style={{ marginTop: "4px", cursor: "pointer" }}
        onClick={() => {
          attachment?.current?.click();
        }}
      />
      <input
        type="file"
        accept="image/png, image/jpg, image/jpeg"
        onChange={(e) => {
          setAttachment(e.target.files[0]);
        }}
        ref={attachment}
        id="attachment"
        hidden
      />
      {hasAttachment ? (
        <div
          className="image-preview-container"
          style={{ position: "relative" }}
        >
          <img src={preview?.url} className="img-fluid" />
          <div className="file-info">
          <small title={preview?.name}>{preview?.name}</small>
          <small>{bytesToSize(preview?.size)}</small>
          </div>
          <h5
            onClick={() => {
              setAttachment(null);
            }}
          >
            x
          </h5>
        </div>
      ) : (
        <>
          <input
            hidden
            value={messageText}
            onChange={(e) => {
              setMessageText(e.target.value);
            }}
          />
          <span
            className="chat-text-inputbox"
            placeholder="Type Something ..."
            id="inputbox"
            onInput={(e) => {
              setMessageText(e.currentTarget.textContent);
            }}
            ref={spanMessage}
            contentEditable={true}
            value={messageText}
          />
        </>
      )}

      <button
        className="send-icon-wrapper"
        style={{ cursor: messageSending ? "progress" : "pointer" }}
        id="send-message-btn"
        title="Ctrl + Enter to send!"
        type="submit"
        ref={sendMessageButton}
      >
        <SendMessageIcon />
      </button>
    </form>
  );
};
